import { Link } from '@tanstack/react-router';
import { appConfig, brand } from '../lib/env.js';

const footerLinks = [
  { label: 'Privacy Policy', to: '/privacy-policy', id: 'privacy-policy' },
  { label: 'Terms and Conditions', to: '/terms-and-conditions', id: 'terms-and-conditions' },
  { label: 'Warranty', to: '/warranty', id: 'warranty' },
  { label: 'Contact Us', to: '/contact-us', id: 'contact-us' },
] as const;

export function SiteHeader() {
  return (
    <header data-name="site-header" className="bg-header text-white">
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3">
        <Link
          to="/"
          data-name="logo-home"
          aria-label={`${brand.name} home`}
          className="shrink-0 rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          <img
            src={brand.logos.header}
            alt={`${brand.name} logo`}
            className="h-10 w-auto sm:h-13"
          />
        </Link>
        <p className="min-w-0 font-heading text-sm leading-tight font-semibold sm:text-lg md:text-xl">
          {appConfig.plannerTitle}
        </p>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer data-name="site-footer" className="mt-auto bg-footer text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-4 py-8 text-center sm:flex-row sm:justify-between sm:text-left">
        <img src={brand.logos.footer} alt={`${brand.name} logo`} className="h-13 w-auto" />
        <nav aria-label="Footer">
          <div className="flex flex-wrap items-center justify-center gap-x-6 text-xs sm:text-sm">
            {footerLinks.map((link) =>
              link.id === 'privacy-policy' && brand.legalUrls?.privacy ? (
                <a
                  key={link.id}
                  href={brand.legalUrls.privacy}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-name={`footer-${link.id}`}
                  className="inline-flex min-h-11 items-center rounded hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  {link.label}
                </a>
              ) : link.id === 'terms-and-conditions' && brand.legalUrls?.terms ? (
                <a
                  key={link.id}
                  href={brand.legalUrls.terms}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-name={`footer-${link.id}`}
                  className="inline-flex min-h-11 items-center rounded hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.id}
                  to={link.to}
                  data-name={`footer-${link.id}`}
                  className="inline-flex min-h-11 items-center rounded hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  {link.label}
                </Link>
              ),
            )}
          </div>
        </nav>
      </div>
      <div className="border-t border-white/25 px-4 py-4 text-center text-xs">
        © {new Date().getFullYear()} {brand.legalName}. All rights reserved.
      </div>
    </footer>
  );
}
